import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AuthCallback } from "@/components/GoogleAuth";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { OwnerRoute, ProtectedRoute, PublicOnlyRoute } from "@/components/RouteGuards";
import AppShell from "@/components/layout/AppShell";
import SignIn from "@/pages/SignIn";
import Home from "@/pages/Home";
import Book from "@/pages/Book";
import Trips from "@/pages/Trips";
import TripDetail from "@/pages/TripDetail";
import Pay from "@/pages/Pay";
import Concierge from "@/pages/Concierge";
import Profile from "@/pages/Profile";
import Owner from "@/pages/Owner";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
        <Routes>
          <Route element={<PublicOnlyRoute />}>
            <Route path="/login" element={<SignIn />} />
            <Route path="/register" element={<Navigate to="/login" replace />} />
          </Route>
          <Route element={<ProtectedRoute />}>
            <Route element={<AppShell />}>
              <Route path="/" element={<Home />} />
              <Route path="/book" element={<Book />} />
              <Route path="/trips" element={<Trips />} />
              <Route path="/trips/:id" element={<TripDetail />} />
              <Route path="/trips/:id/pay" element={<Pay />} />
              <Route path="/concierge" element={<Concierge />} />
              <Route path="/profile" element={<Profile />} />
              <Route element={<OwnerRoute />}>
                <Route path="/owner" element={<Owner />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{ classNames: { toast: "!bg-surface !border-line !text-ivory !rounded-2xl" } }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
